// ─── Pure validators (kept private, used only inside config) ──
const validatePAN = (value) =>
  /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);

const validateTAN = (value) =>
  /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/.test(value);

const validateGST = (value) =>
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value);


// ─── Single source of truth ───────────────────────────────────
export const TAX_CONFIG = {
  pan: {
    maxLength: 10,
    validate: validatePAN,
    error: "PAN must be in the format ABCDE1234F",
    example: "Eg. ABCDE1234F",
  },
  tan: {
    maxLength: 10,
    validate: validateTAN,
    error: "TAN must be in the format PNEA12345B",
    example: "Eg. PNEA12345B",
  },
  gst: {
    maxLength: 15,
    validate: validateGST,
    error: "GST must be in the format 29ABCDE1234F1Z5",
    example: "Eg. 29ABCDE1234F1Z5",
  },
};

// ─── Derived field list — no hardcoding elsewhere ─────────────
export const TAX_FIELDS = Object.keys(TAX_CONFIG); // ["pan", "tan", "gst"]

// ─── Shared sanitizer — uppercase + filter + max length ───────
export const checkTaxInput = (field, value) => {
  const config = TAX_CONFIG[field];
  if (!config) return value;
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, config.maxLength);
};